import axiosGlobalInstance from '../http-instance';

const postTrial = params => {
  return axiosGlobalInstance({
    method: 'POST',
    url: '/trial.php',
    data: params,
    headers: {
      action: 'cadastrar',
      authorized: true,
    }
  });
}

export default postTrial;
